export {
  ACTIVITY,
  INTERACTIVE,
} from 'pluginServices/constants/coursewareTypes';

export const enrollmentTypes = {
  OPEN: 'OPEN',
  PASSPORT: 'PASSPORT',
  LTI: 'LTI',
};

export const sortType = Object.freeze({
  ASC: 'asc',
  DESC: 'desc',
});

export const cohortSortKeys = Object.freeze({
  NAME: 'name',
  START_DATE: 'startDate',
});

export const cohortCheckboxesName = Object.freeze({
  LOCKDOWN_PLUGIN_VERSION: 'lockPluginVersion',
  SUPPORT_ON_DEMAND_CLASSES: 'supportOnDemandEnabled',
  SCORABLE: 'scorable',
  FORCE_UPDATE_ASSESSMENTS: 'forceUpdateAssessments',
  ADD_TO_LIBRARY: 'addToLibrary',
});
